module.exports = __webpack_public_path__ + "static/media/pencil.8b2b9d34.svg";